/**
 * `useAssetApprovalChain(projectId, assetId)` — the canonical read hook for an
 * asset's approval chain assignment + approval progress.
 *
 * Thin `useQuery` wrapper over `assetApprovalChainQuery` so call sites get the
 * assignment with a single import while reads still flow through the
 * queryOptions helper (AD-20). Resolves to `null` when the asset has no
 * approval chain. Stays idle until both ids are known.
 */
import { useQuery } from '@tanstack/react-query';

import { assetApprovalChainQuery } from './approval-chain-assignment.api';

export function useAssetApprovalChain(projectId: string | undefined, assetId: string | undefined) {
  return useQuery(assetApprovalChainQuery(projectId, assetId));
}
